// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.articles',{
        url: '/articles?currentPage&filter&pageSize&inactive&match',
        views: {'productList@product': {
            templateUrl: 'main/product/articles/articles.tpl.html',
            controller: 'ArticlesController as vm'
        }},
        resolve: {
            searchTerms: searchTermResolver
        }
    });
}

// @ngInject
function searchTermResolver($stateParams) {
    return {
        filter: $stateParams.filter,
        currentPage: $stateParams.currentPage,
        pageSize: $stateParams.pageSize,
        inactive: $stateParams.inactive,
        match: $stateParams.match
    };
}

// @ngInject
function ArticlesController($state, searchTerms) {
    var vm = this;

    //Properties
    vm.articles = [];
    vm.filter = '';
    vm.currentPage = 1;
    vm.pageSize = 15;
    vm.match = false;
    vm.inactive = false;
    vm.totalItems = [];

    //Methods
    vm.selectArticle = selectArticle;
    vm.goToNew = goToNew;

    activate();

    function activate() {
        vm.filter = searchTerms.filter ? searchTerms.filter : '';
        vm.currentPage = searchTerms.currentPage > 1 ? searchTerms.currentPage : 1;
        vm.pageSize = searchTerms.pageSize >= 20 ? searchTerms.pageSize : 20;
        vm.match = searchTerms.match ? searchTerms.match == 'true' ? true : false : false;
        vm.inactive = searchTerms.inactive ? searchTerms.inactive == 'true' ? true : false : false;
    }

    function selectArticle(article) {
        $state.go('product.articles.article',
            {
                articleId: article.articleId,
                filter: article.searchTerms.filter,
                currentPage: article.searchTerms.currentPage,
                pageSize: article.searchTerms.pageSize,
                inactive: article.searchTerms.inactive,
                match: article.searchTerms.match
            }
        );
    }
    function goToNew() {
        $state.go('product.articles.new');
    }
}

angular
    .module('product.articles', ['product.articles.article', 'product.articles.articleLabelsPrintDialog', 'product.articles.articleNewIntrastatDialog', 'product.articles.articleChangeItemGroupDialog', 'product.articles.articleAddNewArticleVariantDialog'])
    .config(stateConfig)
    .controller('ArticlesController', ArticlesController);
